import React, { useState } from 'react';
import { Link} from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Home = () => {

  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
  {
    icon: 'fas fa-search',
    label: 'Business Understanding',
    img: '/img/content/tab-content-01.png',
    title: 'Understand Your Business Processes',
    text: 'We begin by deeply understanding your operations, workflows, and business objectives to ensure the ERP solution aligns perfectly with your organizational needs.',
    points: [
      'Discovery workshops with stakeholders',
      'Operational and workflow analysis',
      'Identify system gaps and challenges',
      'Define business objectives and KPIs',
    ],
  },
  {
    icon: 'far fa-file-alt',
    label: 'Process Analysis',
    img: '/img/content/tab-content-05.png',
    title: 'AS-IS and TO-BE Process Alignment',
    text: 'We document current processes and design optimized future workflows aligned with ERP best practices.',
    points: [
      'AS-IS process documentation',
      'Gap analysis and improvement areas',
      'ERP capability mapping',
      'Business validation sessions',
    ],
  },
  {
    icon: 'fas fa-project-diagram',
    label: 'Solution Design',
    img: '/img/content/tab-content-02.png',
    title: 'Design Optimized ERP Architecture',
    text: 'Our experts design a scalable ERP solution including system architecture, security, integrations, and reporting framework.',
    points: [
      'System architecture design',
      'Organizational structure setup',
      'Security and access design',
      'Integration planning',
    ],
  },
  {
    icon: 'fas fa-cogs',
    label: 'Implementation',
    img: '/img/content/tab-content-03.png',
    title: 'Configure and Implement System',
    text: 'We configure Dynamics 365 modules, set up master data, workflows, and validate the system through rigorous testing.',
    points: [
      'Module configuration',
      'Master data setup',
      'Workflow configuration',
      'System testing and validation',
    ],
  },
  {
    icon: 'fas fa-headset',
    label: 'Support & Optimization',
    img: '/img/content/tab-content-04.png',
    title: 'Continuous Support and Enhancement',
    text: 'Post go-live, we provide ongoing support, performance monitoring, enhancements, and user assistance.',
    points: [
      'Post go-live support',
      'Performance monitoring',
      'Continuous improvements',
      'User training and assistance',
    ],
  },
];

  const accordionItems = [
    {
      title: 'Certified Microsoft Expertise',
      body: 'Our team consists of Microsoft-certified consultants with deep experience in Dynamics 365 modules, Power Platform, Azure integrations, and industry-specific solutions.',
    },
    {
      title: 'End-to-End Implementation',
      body: 'From requirement gathering, licensing, configuration, data migration, customization, testing, training, to go-live and post-implementation support – we handle everything.',
    },
    {
      title: 'Long-term Partnership & Support',
      body: "We don't just implement – we stay with you for upgrades, optimizations, new module rollouts, performance tuning, and 24×7 technical assistance.",
    },
  ];

  // ===== Industries Preview =====
const industries = [
  "Manufacturing",
  "Distribution",
  "Engineering & Projects",
  "Retail",
  "Field Service Operations",
  "Industrial Automation",
];

// ===== Why Choose (Home short) =====
const whyChoose = [
  {
    icon: "ti-crown",
    title: "20+ Years Leadership Experience",
    desc: "Industry veterans delivering complex ERP transformations across multiple geographies.",
  },
  {
    icon: "ti-settings",
    title: "Proven ERP Delivery",
    desc: "Successful full lifecycle Dynamics 365 implementations across industries.",
  },
  {
    icon: "ti-check-box",
    title: "Microsoft Best Practices",
    desc: "All solutions follow scalable, upgrade-safe Microsoft standards.",
  },
  {
    icon: "ti-headphone-alt",
    title: "Long-Term Support Partner",
    desc: "Continuous optimization, enhancements, and managed support.",
  },
];

  return (
    <div className="main-wrapper">
      <Navbar />

      {/* ===== BANNER ===== */}
      <div className="main-banner-style02 cover-background header-position">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="header-text w-md-75 w-lg-100 pb-5 pb-lg-0">
                        <h1 className="wow fadeInUp text-primary mb-4" data-wow-delay=".1s">
                            Transform Your Business with Intelligent ERP Solutions</h1>
                        <p className="mb-lg-2-0 w-90 w-md-80 wow fadeInUp" data-wow-delay=".2s">
                            At Source-ERP, we help organizations unlock the full potential of Microsoft Dynamics 365 Finance & Operations 
                            through expert implementation, customization, analytics, and innovative mobile applications. Our solutions 
                            improve operational efficiency, enhance visibility, and accelerate digital transformation.</p>
                        <div className="wow fadeInUp" data-wow-delay=".4s">
                            <a href="contact.html" className="butn me-2 align-middle">Get Started</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 text-center text-lg-end position-relative">
                    <div className="banner-img">
                        <img src="/img/content/content-04.png" alt="Microsoft Dynamics 365"/>
                    </div>
                </div>
            </div>
        </div>
        <div className="header-shape d-none d-sm-block">
            <img src="/img/banner/header-bg2.png" className="img-fluid w-100" alt="..."/>
        </div>
    </div>

      {/* ===== SERVICES ===== */}
      <section className="md mt-lg-n5">
        <div className="container">
          <div className="section-heading2 text-center">
            <span className="alt-font">Exclusive Services</span>
            <h2>Our Core Microsoft Solutions</h2>
          </div>
          <div className="row">
            <div className="col-lg-6 text-center mb-5 mb-lg-0">
              <img src="/img/content/content-05.png" className="img-effect" alt="Dynamics 365 Services" />
            </div>
            <div className="col-lg-6">
              <div className="ps-0 ps-lg-3 ps-xl-5">
                <div className="mb-4 separator-dashed-line-horrizontal-full hover-icon">
                  <h3 className="h5"><span className="service-icon"><i className="ti-briefcase"></i></span>
                  Microsoft Dynamics 365 Finance & Operations Implementation & Support</h3>
                  <p className="display-30">We deliver end-to-end implementation services to ensure a smooth and successful ERP deployment.</p>
                </div>
                <div className="mb-4 separator-dashed-line-horrizontal-full hover-icon">
                  <h3 className="h5"><span className="service-icon"><i className="ti-user"></i></span>Microsoft Dynamics 365 F&O Customization</h3>
                  <p className="display-30">Every business is unique. We customize D365 F&O to match your exact operational requirements.</p>
                </div>
                <div className="mb-4 mb-lg-5 hover-icon">
                  <h3 className="h5"><span className="service-icon"><i className="ti-server"></i></span>
                  Power BI Dashboards & Advanced Analytics</h3>
                  <p className="display-30">Turn your D365 F&O data into actionable insights with powerful Power BI dashboards..</p>
                </div>
                <Link to="/services" className="butn small">Explore All Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ACCORDION ===== */}
      {/* ===== WHY CHOOSE SOURCE-ERP ===== */}
<section className="md bg-light-grey">
  <div className="container">
    <div className="section-heading2 text-center">
      <span className="alt-font">Why Choose Us</span>
      <h2>Why Choose Source-ERP</h2>
    </div>

    <div className="row">
      {whyChoose.map((item, index) => (
        <div className="col-md-6 col-lg-3 mb-4" key={index}>
          <div className="card border-0 shadow-sm text-center h-100 p-4">
            <i className={`${item.icon} display-20 text-primary mb-3`}></i>
            <h5>{item.title}</h5>
            <p className="display-30">{item.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* ===== INDUSTRIES WE SERVE ===== */}
<section className="md">
  <div className="container">
    <div className="section-heading2 text-center">
      <span className="alt-font">Industries</span>
      <h2>Industries We Serve</h2>
    </div>

    <div className="row text-center">
      {industries.map((item, index) => (
        <div className="col-md-4 col-sm-6 mb-4" key={index}>
          <div className="card border-0 shadow-sm h-100 p-4">
            <h5 className="mb-0">{item}</h5>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* ===== CTA ===== */}
      <section className="md parallax cover-background primary-overlay" data-overlay-dark="9" data-background="img/banner/bg1.jpg">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-9 text-center">
                    <h2 className="text-white mb-4">Ready to Transform Your Business with D365 F&O?</h2>
                    <p className="text-white mb-4">
                        Contact us today to discuss your requirements and discover how Source-ERP can help you achieve operational excellence.</p>
                    <Link to="/contact" className="butn white"><span>Get In Touch</span></Link>
                </div>
            </div>
        </div>
    </section>

      {/* ===== HOW IT WORKS / DYNAMIC TABS ===== */}
        <section className="md">
        <div className="container">
            <div className="section-heading2 text-center">
            <span className="alt-font">Our Process</span>
            <h2>How We Deliver Success</h2>
            </div>
        </div>

        <div className="container-fluid">
            <div className="horizontaltab tab-style01">

            {/* ===== TAB HEADERS ===== */}
            <ul className="resp-tabs-list hor_1">
                {tabs.map((tab, index) => (
                <li
                    key={index}
                    className={activeTab === index ? 'resp-tab-active' : ''}
                    onClick={() => setActiveTab(index)}
                    style={{ cursor: 'pointer' }}
                >
                    <i className={tab.icon}></i>
                    <span className="d-lg-block d-md-inline-block align-top">
                    {tab.label}
                    </span>
                </li>
                ))}
            </ul>

            {/* ===== TAB CONTENT ===== */}
            <div className="resp-tabs-container hor_1">
                {tabs.map((tab, index) => (
                <div
                    key={index}
                    style={{ display: activeTab === index ? 'block' : 'none' }}
                >
                    <div className="container">
                    <div className="row align-items-center">

                        {/* image left/right alternate */}
                        <div
                        className={`col-lg-5 mb-4 mb-lg-0 text-center text-lg-start ${
                            index % 2 !== 0 ? 'order-lg-2' : ''
                        }`}
                        >
                        <img
                            src={tab.img}
                            alt={tab.label}
                            className="img-effect"
                        />
                        </div>

                        <div
                        className={`col-lg-5 offset-lg-1 ${
                            index % 2 !== 0 ? 'order-lg-1' : ''
                        }`}
                        >
                        <h3 className="h4 mb-4">{tab.title}</h3>
                        <p>{tab.text}</p>

                        <ul className="list-style mb-0 ps-0">
                            {tab.points.map((point, i) => (
                            <li key={i}>{point}</li>
                            ))}
                        </ul>
                        </div>

                    </div>
                    </div>
                </div>
                ))}
            </div>

            </div>
        </div>
        </section>

      <Footer />
    </div>
  );
};

export default Home;
